import React from 'react';
import { AppIcon } from '../../icons/appIcons.tsx';

interface HorsePhotoPlaceholderProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: { box: 'text-2xl', icon: 'w-8 h-8' },
  md: { box: 'text-4xl', icon: 'w-12 h-12' },
  lg: { box: 'text-6xl', icon: 'w-16 h-16' }
};

export default function HorsePhotoPlaceholder({ size = 'md', className = '' }: HorsePhotoPlaceholderProps) {
  const s = sizeClasses[size];
  return (
    <div
      className={`w-full h-full flex items-center justify-center bg-gradient-to-br from-ggaa-cream to-ggaa-green/10 text-gray-400 ${className}`}
    >
      <AppIcon name="photo" className={`${s.icon} opacity-60`} strokeWidth={1.25} />
    </div>
  );
}
